export const SHOPIFY_LOGIN_URL = "https://accounts.shopify.com/lookup";
